// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 1189 ? "editor" : chunkId) + "." + {"692":"89e11809","1189":"eb1ef7d3","5720":"3ed4ffb5"}[chunkId] + ".css";
};